import { render, staticRenderFns } from "./FlushDatabase.vue?vue&type=template&id=ffbbabf0&"
import script from "./FlushDatabase.vue?vue&type=script&lang=js&"
export * from "./FlushDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports